import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * On every route change: if no hash, scroll to top instantly.
 * If a hash is present (e.g. #kavitatsiooniprotseduurid), wait for the DOM
 * to paint the target section and smoothly scroll to it.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // Give the new page a moment to render, then scroll to the anchor
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (attempt < 20) {
          setTimeout(() => tryScroll(attempt + 1), 60);
        }
      };
      tryScroll();
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
